// Performance improvement: calculate screenWidth just when it was resized.
// Here we try to register event as early as it possible.
const jW = $(window);
let screenWidth: number;
let screenHeight: number;
let _resizingInProgress = false;

function _resizeHandler() {
	screenWidth = jW.width() as number;
	screenHeight = jW.height() as number;
}
_resizeHandler();

$(window).on('resize', function () {
	if (!_resizingInProgress) {
		_resizeHandler();
		_resizingInProgress = true;
		setTimeout(function () {
			_resizeHandler();
			_resizingInProgress = false;
		}, 500);
	}
});

/**
 * @ngdoc service
 * @name mx.app.DeviceService
 * @module mx.app
 *
 * @description
 * A service provides methods for distinguishing device/screen sizes
 *
 * */
export class DeviceService {
	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenDimensions
	 *
	 * @description
	 * Determines the dimensions of a browser window
	 *
	 * @returns {object} An object that contains window's width and height properties
	 */
	screenDimensions() {
		return {
			width: screenWidth,
			height: screenHeight,
		};
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenExtraSmall
	 *
	 * @description
	 * Determines whenever if the device screen is extra small. Less than 600 px.
	 *
	 * @returns {boolean} is the device screen extra small
	 */
	screenExtraSmall(): boolean {
		return screenWidth < 600;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenSmall
	 *
	 * @description
	 * Determines whenever if the device screen is small. In between 600 px and 959 px.
	 *
	 * @returns {boolean} is the device screen small
	 */
	screenSmall(): boolean {
		return screenWidth >= 600 && screenWidth < 960;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenMobile
	 *
	 * @description
	 * Determines whenever if the device screen is mobile size. Less than 960 px.
	 *
	 * @returns {boolean} is the device screen mobile size
	 */
	screenMobile(): boolean {
		return screenWidth < 960;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenDesktop
	 *
	 * @description
	 * Determines whenever if the device screen is desktop size. Greater than 959 px.
	 *
	 * @returns {boolean} is the device screen desktop size
	 */
	screenDesktop(): boolean {
		return screenWidth > 959;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenMiddle
	 *
	 * @description
	 * Determines whenever if the device screen is middle size. In between 960 px and 1439 px.
	 *
	 * @returns {boolean} is the device screen middle size
	 */
	screenMiddle(): boolean {
		return screenWidth > 959 && screenWidth < 1440;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenWide
	 *
	 * @description
	 * Determines whenever if the device screen is wide. Greater than 1439 px.
	 *
	 * @returns {boolean} is the device screen wide
	 */
	screenWide(): boolean {
		return screenWidth > 1439;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#screenExtraWide
	 *
	 * @description
	 * Determines whenever if the device screen is extra wide. Greater than 1699 px.
	 *
	 * @returns {boolean} is the device screen extra wide
	 */
	screenExtraWide(): boolean {
		return screenWidth > 1699;
	}

	/**
	 * @ngdoc method
	 * @name mx.app.DeviceService#isMobileDevice
	 *
	 * @description
	 * Determines if the device is a mobile device.
	 *
	 * @returns {boolean} is the device is a mobile device.
	 */
	isMobileDevice(): boolean {
		return this.screenMobile() && 'ontouchstart' in document;
	}
}
